module.exports = __webpack_public_path__ + "img/wallet.caa51bed.png";